<div style="max-width: 600px; margin: auto; padding: 20px;">
  <h2>Socket.IO Chat</h2>

  <div *ngIf="!isRegistered">
    <input
      [(ngModel)]="username"
      placeholder="Enter your username"
      class="form-control"
    />
    <button (click)="register()" class="btn btn-primary mt-2">
      Register
    </button>
  </div>

  <div *ngIf="isRegistered">
    <p><strong>Logged in as:</strong> {{ username }}</p>

    <input
      [(ngModel)]="recipient"
      placeholder="Recipient username"
      class="form-control"
    />
    <textarea
      [(ngModel)]="message"
      placeholder="Enter message"
      class="form-control mt-2"
    ></textarea>
    <button (click)="send()" class="btn btn-success mt-2">
      Send Message
    </button>

    <hr />

    <h5>Messages</h5>
    <div
      *ngFor="let msg of messages"
      style="border: 1px solid #ccc; padding: 10px; margin-top: 5px;"
    >
      <strong>{{ msg.from === username ? 'You' : msg.from }}:</strong>
      {{ msg.message }}
    </div>
  </div>
</div>
